var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-type-caption text-uppercase text-gray-600"},[_vm._v(" #"+_vm._s(_vm.getOrderId())+" - "+_vm._s(_vm.getOrderTotPrice())+" ")]),_c('span',[_vm._v(_vm._s(_vm.getFamilyName()))])])}
var staticRenderFns = []

export { render, staticRenderFns }